import externalLinks from './external_links'
import gobackLink from './goback_link'
import loginFooter from './login_footer'
export default {
  externalLinks,
  gobackLink,
  loginFooter,
}
